export default __webpack_public_path__ + "static/media/ai-creator.0bc8fa37.svg";